import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { FieldDef } from '../types'

interface Props {
  field: FieldDef
  value: string
  onChange: (v: string) => void
}

export default function EnumWidget({ field, value, onChange }: Props) {
  return (
    <FormControl size="small" sx={{ minWidth: 240 }}>
      <InputLabel>{field.label}</InputLabel>
      <Select
        value={value ?? ''}
        label={field.label}
        onChange={(e) => onChange(e.target.value as string)}
      >
        {(field.options || []).map((opt) => (
          <MenuItem key={opt} value={opt}>
            {opt}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
